module.exports = {
	'customFolder.m4.m410140_browse': {
		'assessmentYear': '考核年度',
		'assessmentPeriod': '考核期间',
		'assessmentScore': '评核分数',
		'isItApproved': '是否通过',
		'through': '通过',
		'notPassed': '未通过',
		'assessmentType': '考核种类',
		'assessmentLevelRegulations': '评核等级规则',
		'assessmentLevel': '评核等级',
		'comment': '评语',
		'assessmentStage': '考核阶段',
		'supervisorSName': '主管姓名',
		'assessmentPersonnel': '考核人员',
		'stageScore': '阶段分数',
		'stageAssessmentLevelRules': '阶段评核等级规则',
		'stageAssessmentLevel': '阶段评核等级',
		'assessmentPlanName': '阶段名称',
		'nonEmployee': '非员工',
	},
	'customFolder.m4.m410140': {
		'assessmentManagementName': '考核管理名称',
		'startOfTheYear': '年度起',
		'yearToDate': '年度迄',
	},
	'customFolder.service.m3.service-m310250': {
		'supervisorSAffiliatedCompany': '主管所属公司',
		'theCompanyToWhichTheAssessor': '考核人员所属公司',
		'staffPerformanceRecordDetails': '部属绩效纪录明细表',
	},
};
